// react
import React from "react";

// components
import StatusAnimation from "../../../../../containers/TaskRunner/components/Status/StatusAnimation";

// config
import Config from "../../Config";

export default class RunningIndicator extends React.Component {
	componentDidMount() {
		this.svgAnimation = new StatusAnimation(
			this.container,
			Config.animationSize,
			Config.running.amplitude,
			Config.running.speed,
			Config.running.color,
			Config.running.strokeWidth
		);
		this.svgAnimation.start(Config.running.frameRate);
	}

	componentWillUnmount() {
		this.svgAnimation.finish();
	}

	render() {
		return (
			<svg width={Config.animationSize} height={Config.animationSize}>
				<g
					transform="translate(0, 0)"
					ref={(node) => {
						this.container = node;
					}}
				/>
			</svg>
		);
	}
}
